export default function iosHack () {
  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
  if (iOS) {
    const bodyEl = document.querySelector('body')
    bodyEl.classList.add('is-ios')
  }
}



// WEBPACK FOOTER //
// ./src/utils/iosHack.js